import { Box, Breadcrumbs, Button, Container, FormControl, FormControlLabel, FormLabel, Grid, Link, MenuItem, Paper, Radio, RadioGroup, Select, Stack, TextField, Typography } from "@mui/material";
import { useForm } from 'react-hook-form';
import axios from "axios";
import { config } from "../../data/config";
import Swal from 'sweetalert2'
import { useCookies } from 'react-cookie';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import * as React from 'react';
import SingleFileuploader from "../../component/singlefileuploader";
import { CheckBox } from "@mui/icons-material";

export default function EditCateogry() {
    let { Id } = useParams();

    const [cookies, setCookie] = useCookies(['token', 'rule']);
    const [data, setData] = React.useState(null);
    const [listgroup, setList] = React.useState(null);
    const [addon, setAddon] = React.useState('');

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const load = async () => {
        var path = `${config.url}/feature/all`;

        try {
            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': `multipart/form-data`,
                    'Authorization': cookies.token
                }
            });
            setList(res.data)


        } catch (error) {

        }
        try {
            var path = `${config.url}/cat/${Id}`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': `application/json`,
                    'Authorization': cookies.token
                }
            });
            setData(res.data)
        } catch (error) {

        }
    }
    const handleChange = (event) => {
        setAddon(event.target.value);
    };


    const submit = async (data2) => {
        var path = `${config.url}/cat/${data['_id']['$oid']}`;
        var mydata = {
            name: data2.name,
            url: data2.url,
            addon: addon,

        };
        try {
            let res = await axios({
                method: 'put',
                url: path,
                data: mydata,
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': `application/json`,
                    'Authorization': cookies.token
                }
            });

            window.location.href = '/dashboard/category';


        } catch (error) {
            console.log('error')
            Swal.fire(error.response.data.message)
            error.response.data.error == null ?
                Swal.fire(error.response.data.message)
                :
                Swal.fire({
                    title: error.response.data.message,
                    html: `<div>
                ${Object.keys(error.response.data.error).map((field) => (
                        ` <div key=${field}>
                 ${error.response.data.error[field].map((message) => (
                            `<a style="font-size:15px"  key={message}> ${message}</a>`
                        ))}
               </div>`
                    ))}
              </div>`

                })
        }

    }
    useEffect(() => {
        load();
    }, []);
    return (
        <Container dir={'rtl'}>
            <Box pb={3} pt={3}>
                <Breadcrumbs aria-label="breadcrumb">
                    <Link underline="hover" color="inherit" href="/dashboard">
                    داشبورد
                    </Link>
                    <Link underline="hover" color="inherit" href="/dashboard/category">
                    لیست دسته بندی ها
                    </Link>
                    <Typography color="text.primary">ویرایش</Typography>
                </Breadcrumbs>
                <Typography variant='h1' color={'gray'} fontSize={34}>ویرایش دسته بندی</Typography>
            </Box>
            <Paper>
                <Box>


                    {data != null &&
                        <form onSubmit={handleSubmit((data) => submit(data))} >
                            <Box p={4}
                                borderRadius={2}>
                                <Grid container>
                                    <Grid xs={12} sm={4}>
                                        <SingleFileuploader component="category" parent={data['_id']['$oid']} />
                                    </Grid>
                                    <Grid xs={12} sm={8}>
                                        <Grid container>
                                            <Grid xs={12} md={12}>
                                                <Box p={1}>
                                                    <TextField
                                                        fullWidth
                                                        {...register('name', { required: true })} defaultValue={data.name}
                                                        required variant={'filled'} label="نام" type="text" ></TextField>
                                                </Box>
                                            </Grid>
                                            <Grid xs={12} md={12}>
                                                <Box p={1}>
                                                    <TextField
                                                        fullWidth
                                                        {...register('url', { required: true })} defaultValue={data.url}
                                                        required variant={'filled'} label="url" type="text" ></TextField>
                                                </Box>
                                            </Grid>


                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Box pt={6}>
                                    <Stack direction={'row'}>
                                        <Box m={1}>
                                            <Button type="submit" variant={'contained'}>بروز رسانی</Button>
                                        </Box>

                                        <Box m={1}>
                                            <Button href="/dashboard/category" variant={'outlined'}>بازگشت</Button>
                                        </Box>

                                    </Stack>

                                </Box>
                            </Box>
                        </form>
                    }
                </Box>
            </Paper>
        </Container>
    )
}